import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { VideoItem } from 'services/data-manager/types';

import { HOVER_EPISODE, HOVER_SEASON } from 'screens/Detail/languageConst';

function usePlayerProgramTitle(videoItem: VideoItem | undefined) {
    const { t } = useTranslation();

    return useMemo(() => {
        const arr: string[] = [];
        const seriesId = videoItem?.seriesId;
        const seasonNumber = videoItem?.seasonNumber;
        const episodeNumber = videoItem?.episodeNumber;
        const seriesTitle = videoItem?.seriesTitle;
        const eventTitle = videoItem?.title;

        if (seriesId && seasonNumber != null) {
            arr.push(`${t(HOVER_SEASON)}${seasonNumber}`);
        }

        if (seriesId && episodeNumber != null) {
            arr.push(`${t(HOVER_EPISODE)}${episodeNumber}`);
        }

        if (seriesTitle) {
            arr.push(seriesTitle);
        } else if (eventTitle) {
            arr.push(eventTitle);
        }

        if (arr.length) {
            return arr.join(' ');
        }

        return '';
    }, [t, videoItem]);
}

export default usePlayerProgramTitle;
